export const ROLE_TYPES = {
  RESI_ADMIN: 'e5566d12-e6dc-4ea7-b994-b83cc01d9ab5',
  RESI_SALES: '85546d18-86d8-8ea8-b898-883cc0189ab8',
  RESI_SUCCESS: '45128757-2360-4ff0-9f5d-ed21294d9de4',
  RESI_SUPPORT: '40673c33-cfc8-4c16-a752-f2a428d3ddce',
  RESI_VIEWER: '2c559ecf-d44d-4952-848c-e8bb3bc96d58',
  CUSTOMER_ADMIN: '63566d12-e6dc-2ea7-b994-a83cc01d9ab3',
  EVENT_ADMIN: '75984d8c-79de-46b0-a8aa-762446f8fc89',
  CONTROL_ENCODER: 'a5366d12-e6dc-2ea7-a994-b83cc01d9ab6',
  MEDIA_LIB_ADMIN: 'aa13006f-a8a9-49a4-a99a-7eeccb7b1c49',
  CAMPUS_REVIEW: 'f9996d12-e7dc-54a7-b995-b83cc01d9dde',
  HARDWARE_ADMIN: '35366413-36d3-34a3-3994-383c441d9ab3',
} as const;

export const RESI_INTERNAL_ROLES: string[] = [
  ROLE_TYPES.RESI_VIEWER,
  ROLE_TYPES.RESI_SUCCESS,
  ROLE_TYPES.RESI_SUPPORT,
  ROLE_TYPES.RESI_ADMIN,
];

export const DEFAULT_RESI_INTERNAL_ROLE: string = ROLE_TYPES.RESI_VIEWER;

export const availableRoles = [
  ROLE_TYPES.CONTROL_ENCODER,
  ROLE_TYPES.CUSTOMER_ADMIN,
  ROLE_TYPES.EVENT_ADMIN,
  ROLE_TYPES.MEDIA_LIB_ADMIN,
  ROLE_TYPES.CAMPUS_REVIEW,
  ROLE_TYPES.HARDWARE_ADMIN,
  ...RESI_INTERNAL_ROLES,
];

export const PERMISSIONS_GROUPS = {
  viewDashboard: [
    ROLE_TYPES.RESI_ADMIN,
    ROLE_TYPES.CUSTOMER_ADMIN,
    ROLE_TYPES.EVENT_ADMIN,
    ROLE_TYPES.MEDIA_LIB_ADMIN,
    ROLE_TYPES.CONTROL_ENCODER,
  ],
  manageEncoderAndWebSettings: [
    ROLE_TYPES.RESI_ADMIN,
    ROLE_TYPES.CUSTOMER_ADMIN,
    ROLE_TYPES.EVENT_ADMIN,
    ROLE_TYPES.CONTROL_ENCODER,
  ],
  manageSched: [ROLE_TYPES.RESI_ADMIN, ROLE_TYPES.CUSTOMER_ADMIN, ROLE_TYPES.EVENT_ADMIN, ROLE_TYPES.CONTROL_ENCODER],
  manageUsers: [ROLE_TYPES.RESI_ADMIN, ROLE_TYPES.CUSTOMER_ADMIN],
  manageVenues: [ROLE_TYPES.RESI_ADMIN, ROLE_TYPES.CUSTOMER_ADMIN],
  manageSocialMedia: [ROLE_TYPES.RESI_ADMIN, ROLE_TYPES.CUSTOMER_ADMIN, ROLE_TYPES.EVENT_ADMIN],
  manageDestinationGroups: [
    ROLE_TYPES.RESI_ADMIN,
    ROLE_TYPES.CUSTOMER_ADMIN,
    ROLE_TYPES.EVENT_ADMIN,
    ROLE_TYPES.CONTROL_ENCODER,
  ],
  manageCues: [
    ROLE_TYPES.RESI_ADMIN,
    ROLE_TYPES.CUSTOMER_ADMIN,
    ROLE_TYPES.EVENT_ADMIN,
    ROLE_TYPES.MEDIA_LIB_ADMIN,
    ROLE_TYPES.CONTROL_ENCODER,
  ],
  bandwidthAnalytics: [ROLE_TYPES.RESI_ADMIN, ROLE_TYPES.CUSTOMER_ADMIN],
  videoReview: [
    ROLE_TYPES.CONTROL_ENCODER,
    ROLE_TYPES.CUSTOMER_ADMIN,
    ROLE_TYPES.EVENT_ADMIN,
    ROLE_TYPES.MEDIA_LIB_ADMIN,
    ROLE_TYPES.RESI_ADMIN,
    ROLE_TYPES.CAMPUS_REVIEW,
  ],
  accountDetails: [
    ROLE_TYPES.RESI_ADMIN,
    ROLE_TYPES.CUSTOMER_ADMIN,
    ROLE_TYPES.EVENT_ADMIN,
    ROLE_TYPES.MEDIA_LIB_ADMIN,
    ROLE_TYPES.CONTROL_ENCODER,
  ],
};
